import { RootState } from '@/store';
import { Module } from 'vuex';
import { AppManagerState, AppMap } from './types';
import LocationManager from './location-manager';

export const appManagerModule: Module<AppManagerState, RootState> = {
    namespaced: true,
    state: {
        currentAppId: -1,
        openedAppIds: [],
        openedAppMap: {}
    },
    mutations: {
        goHome: (state: AppManagerState) => {
            state.currentAppId = -1;
            LocationManager.updateDesktopUrlWhenNoApp();
        },
        setCurrentAppId: (state: AppManagerState, payload: number) => (state.currentAppId = payload),
        setOpenedAppMap: (state: AppManagerState, payload: AppMap) => (state.openedAppMap = payload),
        setOpenedAppIds: (state: AppManagerState, payload: Array<number>) => (state.openedAppIds = payload)
    },
    getters: {
        currentApp(state: AppManagerState) {
            if (state.currentAppId in state.openedAppMap) {
                return state.openedAppMap[state.currentAppId];
            } else {
                return null;
            }
        }
    }
};
